import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from '../base-select';
import CustomOption from './components/custom-option';
import { SIZES } from '../base-select/constants';

const IconSelect = ({
  options,
  size = SIZES.small,
  invalid = false,
  disabled = false,
  onChange = Function.prototype,
  defaultValue = null,
}) => (
  <BaseSelect
    className="ws-ui-icon-select"
    clearable={false}
    onChange={onChange}
    options={options}
    components={{ Option: CustomOption, SingleValue: CustomOption }}
    size={size}
    defaultValue={defaultValue}
    invalid={invalid}
    disabled={disabled}
  />
);

IconSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      glyph: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  defaultValue: PropTypes.shape(),
};

export default IconSelect;
